<template>
  <v-dialog
    :model-value="modelValue"
    width="700"
    @update:model-value="onDialogVisibility"
    @click:outside="closeModal"
  >
    <v-card rounded="lg">
      <div class="bg-red-600 relative">
        <i
          class="mdi mdi-close text-xl cursor-pointer text-white absolute top-2 right-3"
          @click="closeModal"
        ></i>
        <h2 class="text-xl font-semibold text-white py-5 pl-10">BAST IMKP</h2>
      </div>

      <div class="px-10 py-5">
        <div v-if="loading" class="py-10 text-center text-gray-500">
          Memuat data BAST…
        </div>

        <template v-else>
          <v-form ref="formBast" @submit.prevent="handleSubmit">
            <div class="mb-4">
              <p class="text-xs font-semibold text-gray-500 mb-1">
                Judul Proyek
              </p>
              <p class="text-sm font-medium text-gray-800">
                {{ judulProyek || "-" }}
              </p>
            </div>

            <div class="rounded-lg border border-gray-200 overflow-hidden mb-4">
              <div
                class="bg-red-100 text-red-700 text-sm font-semibold px-4 py-2 flex justify-between"
              >
                <span>Daftar Periksa</span>
                <span>Y</span>
              </div>
              <div
                v-for="item in penutupanArray"
                :key="item.id"
                class="flex items-center justify-between px-4 py-2 border-t border-gray-100 text-sm"
              >
                <span class="text-gray-700">
                  {{ item.name }}<span class="text-red-600">*</span>
                </span>
                <span class="text-green-600 font-semibold">✓</span>
              </div>
            </div>

            <template v-if="isEditable">
              <v-file-input
                v-model="fileBast.file"
                label="Upload File BAST"
                accept=".pdf"
                variant="outlined"
                density="compact"
                color="#475569"
                prepend-icon=""
                prepend-inner-icon="mdi-cloud-upload-outline"
                multiple
                chips
                hide-details="auto"
                :rules="formValidasi.file"
                @update:model-value="onFileChange"
              />
              <p class="text-xs text-red-600 font-medium mt-1">
                * Pastikan file BAST sudah disetujui dan ditandatangani oleh
                Kontraktor Pelaksana dan Kustodian.
              </p>
            </template>

            <div
              v-if="fileBast.assets.length >= 1"
              class="text-sm my-3 font-medium"
            >
              <span>File saat ini :</span>
              <ul class="mt-1">
                <li v-for="(file, index) in fileBast.assets" :key="index">
                  <a
                    class="text-red-600 font-normal cursor-pointer"
                    style="text-decoration: none"
                    @click="downloadFile(file, formatFilename)"
                  >
                    File BAST_{{ index + 1 }}.pdf
                  </a>
                </li>
              </ul>
            </div>

            <div class="flex justify-end gap-3 mt-5">
              <FormButton
                label="Tutup"
                variant="outlined"
                classes="capitalize text-gray-500"
                @click="closeModal"
              />
              <FormButton
                v-if="isEditable"
                label="Simpan"
                classes="bg-red-600 text-white capitalize"
                @click="handleSubmit"
              />
            </div>
          </v-form>
        </template>
      </div>
    </v-card>
  </v-dialog>

  <ConfirmModal
    v-model="dialogConfirm"
    img="warning.png"
    title="BAST IMKP"
    description="Apakah anda yakin akan melakukan BAST IMKP ini?"
    wording-cancel="Batal"
    wording-confirm="Ya"
    :loading="submitting"
    @close-modal="dialogConfirm = false"
    @confirm-data="submitBast"
  />
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import FormButton from "@/components/FormButton.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import axios from "axios";
import { API_BASE_URL, CMS_IMKP_DETAIL, CMS_SET_BAST } from "@/constants";
import { statusIMKPEnum } from "@/utilities/enum";
import { downloadFile } from "@/utilities/globalFunction";
import UploadFileService from "@/utilities/upload-file";
import { FormValidasiImkp } from "@/pages/imkp/core/FormData";
import util from "@/assets/js/util";
import { cloneDeep } from "lodash";

const url_imkp_detail = API_BASE_URL + CMS_IMKP_DETAIL;
const url_proses_bast = API_BASE_URL + CMS_SET_BAST;
const max_file_size = 5;

const DEFAULT_PENUTUPAN = [
  {
    id: 1,
    name: "Apakah pekerjaan telah selesai sesuai dengan kontrak?",
    c_q: true,
  },
  {
    id: 2,
    name: "Apakah telah dilakukan pemeriksaan terkait dengan QA/QC?",
    c_q: true,
  },
];

export default {
  name: "BastImkpModal",
  mixins: [GlobalDataMixin],
  components: {
    FormButton,
    ConfirmModal,
  },
  emits: ["update:modelValue", "submitted"],
  props: {
    modelValue: { type: Boolean, default: false },
    imkpId: { type: [Number, String], default: null },
    status: { type: [Number, String], default: null },
    judulProyek: { type: String, default: "" },
    namaKontraktor: { type: String, default: "" },
    sioId: { type: [Number, String], default: null },
  },
  data() {
    return {
      statusIMKPEnum,
      loading: false,
      submitting: false,
      dialogConfirm: false,
      penutupanArray: cloneDeep(DEFAULT_PENUTUPAN),
      fileBast: {
        file: [],
        assets: [],
      },
      formatFilename: "",
    };
  },
  computed: {
    userRole() {
      return Array.isArray(this.userData.role) ? "isafe" : this.userData.role;
    },
    isEditable() {
      return (
        this.status === statusIMKPEnum.IMKP_PUBLISHED ||
        this.status === statusIMKPEnum.BAST_REVISION
      );
    },
    formValidasi() {
      return {
        file: FormValidasiImkp.filePersyaratanKhusus,
        penutupanChecklist: [
          (v) =>
            (v !== null && v !== undefined) || "Daftar periksa harus diisi.",
        ],
      };
    },
  },
  created() {
    this.uploadFileService = new UploadFileService(
      this.userData.token,
      this.userRole,
    );
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.resetForm();
        this.fetchDetail();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    downloadFile,
    resetForm() {
      this.penutupanArray = cloneDeep(DEFAULT_PENUTUPAN);
      this.fileBast = { file: [], assets: [] };
      this.formatFilename = "";
      this.dialogConfirm = false;
      this.$nextTick(() => {
        this.$refs.formBast?.resetValidation();
      });
    },
    async handleSubmit() {
      const { valid } = await this.$refs.formBast.validate();
      if (!valid) return;
      this.dialogConfirm = true;
    },
    async fetchDetail() {
      if (!this.imkpId) return;
      try {
        this.loading = true;
        const result = await axios.get(url_imkp_detail, {
          params: { id: this.imkpId },
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        const res = result.data.data[0];
        this.fileBast.assets = res?.fileBast ? JSON.parse(res.fileBast) : [];
        this.formatFilename =
          "File BAST " + this.judulProyek + "-" + this.namaKontraktor;
      } catch (error) {
        console.log("ERR fetchDetail BAST : ", error);
        util.showError("Terjadi kesalahan saat memuat data BAST.");
      } finally {
        this.loading = false;
      }
    },
    onFileChange(files) {
      const arrFile = Array.isArray(files) ? files : files ? [files] : [];
      const invalid = arrFile.find(
        (item) =>
          item.type !== "application/pdf" ||
          item.size > max_file_size * 1024 * 1024,
      );

      if (invalid) {
        if (invalid.type !== "application/pdf") {
          util.showError("Ekstensi file harus .pdf!");
        } else {
          util.showError(
            "Ukuran file melebihi batas max " + max_file_size + "MB !",
          );
        }
        this.fileBast.file = [];
        return;
      }

      this.fileBast.file = arrFile;
    },
    async uploadFiles() {
      this.fileBast.assets = [];
      for (const file of this.fileBast.file) {
        try {
          const res = await this.uploadFileService.uploadFile(file);
          this.fileBast.assets.push(res.filename);
        } catch (error) {
          util.showError("Terjadi kesalahan saat upload file!");
        }
      }
    },
    async submitBast() {
      try {
        this.submitting = true;
        await this.uploadFiles();

        const bodyJson = {
          id: this.imkpId,
          usecase: "kontraktor",
          idSio: this.sioId,
          kontraktorId: parseInt(this.userData.kontraktorID),
          penutupanIzinBekerjaQ1: this.penutupanArray.find(
            (item) => item.id === 1,
          ).c_q,
          penutupanIzinBekerjaQ2: this.penutupanArray.find(
            (item) => item.id === 2,
          ).c_q,
          fileBast: JSON.stringify(this.fileBast.assets),
        };

        await axios.post(url_proses_bast, bodyJson, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        util.showInfo("BAST IMKP berhasil!", 2000);
        this.dialogConfirm = false;
        this.$emit("submitted");
        this.closeModal();
      } catch (error) {
        console.log("ERR submitBast : ", error);
        util.showError("Terjadi kesalahan saat submit BAST IMKP!");
      } finally {
        this.submitting = false;
      }
    },
    closeModal() {
      this.onDialogVisibility(false);
    },
    onDialogVisibility(open) {
      this.$emit("update:modelValue", open);
    },
  },
};
</script>
